/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $(document).ready(function() {

            //homepage filter
            function update_home_models(make){
                console.log(make);
                $("form.inventory-filter select.model option").hide();
                $("form.inventory-filter select.model option[data-make='all']").attr('selected','selected');
                $("form.inventory-filter select.model option[data-make='"+make+"']").show();
            }

            var home_make_filter = $("form.inventory-filter select.make");
            home_make_filter.change(function(){
                var make = $(this).find("option:selected").attr('value');
                update_home_models(make);
            });

        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Home page
    'inventory': {
      init: function() {

        $(document).ready(function() {

            // JavaScript to be fired on the Inventory page
            // reset the form (all makes - all models)
            // load makes andmodels into options

            // Load get variables (set to 'all' if undefined)
            // Check if Make exists (in make array?)
            // If not, set Make to all, set Model to all
            // else, set make to Maketest if model exists
                // if not set to all
                // else set to model

            var vehicles = $(".vehicle");
            $(".vehicle").hide();

            // Selects
            var make_select     = $(".vehicle-filter select.make");
            var model_select    = $(".vehicle-filter select.model");

            // Vehicle data
            var vehicle_data = $("#select-data div");
            var makes = [];
            var models = [];

            // populate make data
            $.each(
                vehicle_data, function(index, make){
                    makes.push(make.dataset["make"]);
                    $.each(
                        make.dataset["models"].split(","), function(index, model){
                            models.push(model);
                        }
                    );
                }
            );

            // populate selects
            initialize_selects();


            var get = [];

            //Retrieve and set make and model from get
            location.search.replace('?', '').split('&').forEach(function(val){
                split = unescape(val).replace(/\+/g,' ').split('=', 2);
                //split = val.replace('/\+/g', ' ').split('=', 2);
                get[split[0]] = split[1];
            });


            console.log("model = " + get['model']);

            //set make and model, returns 'all' if make/model doesn't exist
            make = set_value(get['make'], makes)
            model = set_value(get['model'], models);

            console.log("make = "+make);
            console.log("model = "+model);

            update_selects(make, model);


            setTimeout(
              function()
              {
                show_vehicles(make, model);
              }, 1000
            );


            //watch for changes
            var vehicles = $(".vehicle");


            make_select.change(function(){
                vehicles.hide();
                //get the value of the selected vehicle
                var make = $(this).find("option:selected").attr('value');
                show_vehicles(make);
                initialize_selects();
                update_selects(make, model);
            });

            model_select.change(function(){
                vehicles.hide();
                var make = make_select.find("option:selected").attr('value');
                var model = $(this).find("option:selected").attr('value');
                show_vehicles(make, model);
                initialize_selects();
                update_selects(make, model);
            });

            function show_vehicles(make, model) {
                console.log(make);
                console.log(vehicles);
                if (make === "all"){
                    vehicles.show();
                }
                else {
                    if (model === undefined || model === "all") {
                        $(".vehicle[data-make='"+make+"']").show();
                    }
                    else {
                        $(".vehicle[data-make='"+make+"'][data-model='"+model+"']").show();
                    }

                }

            }


            function update_selects(make, model){

                make_select.find('option[value="'+make+'"]').attr('selected', 'selected');
                //console.log(model_select);
                model_select.find('option[data-make="'+make+'"]').show();
                model_option = model_select.find('option[data-make="'+make+'"][data-model="'+model+'"]').val();
                if (model_option === undefined) {
                    model_select.find('option[value="all"]').attr('selected', 'selected');
                }
                else {
                    model_select.find('option[data-model="'+model+'"]').attr('selected', 'selected');
                }

            }


            function set_value(value, array){
                if ($.inArray(value, array) > -1) {
                    return value;
                }
                else {
                    return 'all';
                }
            }

            function initialize_selects(){
                make_select.empty();
                model_select.empty();
                make_select.append('<option value="all" >All Makes</option>');

                vehicle_data.each(function(index, value){
                    var make = value.dataset["make"];
                    //var model = $(value).data("model");
                    make_select.append('<option value="'+make+'" >'+make+'</option>');

                    $.each(value.dataset["models"].split(','),
                        function(index, model) {
                            model_select.append('<option data-make="'+make+'" data-model="'+model+'" value="'+model+'" >'+model+'</option>');
                        }
                    );

                });

                //$(".vehicle-filter select.model option").hide();
                model_select.find('option').hide();
                model_select.prepend('<option value="all" >All Models</option>');
                model_select.find('option[value="all"]').attr('selected', 'selected');
            }

        });
      },
      finalize: function() {
        // JavaScript to be fired on the inventory page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'credit_application': {
        init: function() {
            $(document).ready(function(){

                $('#no-co').prop('checked', true);
                $('.required-field').prop("required", false);


                $('input[type=radio][name=borrow-type]').change(function(){
                    //alert(this.value);
                    console.log(this.value);

                    if(this.value === "yes"){
                        $('.borrower-form').removeClass('col-centered col-lg-8').addClass('col-lg-6');
                        $('.where').removeClass('col-lg-8').addClass('col-lg-12');

                        $('.required-field').prop("required", true);
                    }
                    if(this.value === "no"){
                        $('.borrower-form').removeClass('col-lg-6').addClass('col-centered col-lg-8');
                        $('.where').removeClass('col-lg-12').addClass('col-lg-8');
                        $('.required-field').prop("required", false);
                    }

                    $('.co-borrow-alert').toggleClass('show');
                    $('.co-borrower-form').toggle();
                });
            });
        }
    },
    'single_vehicle': {
      init: function() {
        // JavaScript to be fired on the about us page

        var initPhotoSwipeFromDOM = function(gallerySelector) {

        // parse slide data (url, title, size ...) from DOM elements
        // (children of gallerySelector)
        var parseThumbnailElements = function(el) {
            var thumbElements = el.childNodes,
                numNodes = thumbElements.length,
                items = [],
                figureEl,
                linkEl,
                size,
                item;

            for(var i = 0; i < numNodes; i++) {

                figureEl = thumbElements[i]; // <figure> element

                // include only element nodes
                if(figureEl.nodeType !== 1) {
                    continue;
                }

                linkEl = figureEl.children[0]; // <a> element
                console.log(linkEl);
                size = linkEl.getAttribute('data-size').split('x');

                // create slide object
                item = {
                    src: linkEl.getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10)
                };



                if(figureEl.children.length > 1) {
                    // <figcaption> content
                    item.title = figureEl.children[1].innerHTML;
                }

                if(linkEl.children.length > 0) {
                    // <img> thumbnail element, retrieving thumbnail url
                    item.msrc = linkEl.children[0].getAttribute('src');
                }

                item.el = figureEl; // save link to element for getThumbBoundsFn
                items.push(item);
            }

            return items;
        };

        // find nearest parent element
        var closest = function closest(el, fn) {
            return el && ( fn(el) ? el : closest(el.parentNode, fn) );
        };

        // triggers when user clicks on thumbnail
        var onThumbnailsClick = function(e) {
            e = e || window.event;
            e.preventDefault ? e.preventDefault() : e.returnValue = false;

            var eTarget = e.target || e.srcElement;

            // find root element of slide
            var clickedListItem = closest(eTarget, function(el) {
                return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
            });

            if(!clickedListItem) {
                return;
            }

            // find index of clicked item by looping through all child nodes
            // alternatively, you may define index via data- attribute
            var clickedGallery = clickedListItem.parentNode,
                childNodes = clickedListItem.parentNode.childNodes,
                numChildNodes = childNodes.length,
                nodeIndex = 0,
                index;

            for (var i = 0; i < numChildNodes; i++) {
                if(childNodes[i].nodeType !== 1) {
                    continue;
                }

                if(childNodes[i] === clickedListItem) {
                    index = nodeIndex;
                    break;
                }
                nodeIndex++;
            }



            if(index >= 0) {
                // open PhotoSwipe if valid index found
                openPhotoSwipe( index, clickedGallery );
            }
            return false;
        };

        // parse picture index and gallery index from URL (#&pid=1&gid=2)
        var photoswipeParseHash = function() {
            var hash = window.location.hash.substring(1),
            params = {};

            if(hash.length < 5) {
                return params;
            }

            var vars = hash.split('&');
            for (var i = 0; i < vars.length; i++) {
                if(!vars[i]) {
                    continue;
                }
                var pair = vars[i].split('=');
                if(pair.length < 2) {
                    continue;
                }
                params[pair[0]] = pair[1];
            }

            if(params.gid) {
                params.gid = parseInt(params.gid, 10);
            }

            return params;
        };

        var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
            var pswpElement = document.querySelectorAll('.pswp')[0],
                gallery,
                options,
                items;

            items = parseThumbnailElements(galleryElement);

            // define options (if needed)
            options = {

                // define gallery index (for URL)
                galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                getThumbBoundsFn: function(index) {
                    // See Options -> getThumbBoundsFn section of documentation for more info
                    var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                        pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect();

                    return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                },

                escKey: true,
                closeEl:true,
                captionEl: true,
                fullscreenEl: true,
                zoomEl: true,
                shareEl: true,
                counterEl: true,
                arrowEl: true,
                preloaderEl: true,


            };

            // PhotoSwipe opened from URL
            if(fromURL) {
                if(options.galleryPIDs) {
                    // parse real index when custom PIDs are used
                    // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                    for(var j = 0; j < items.length; j++) {
                        if(items[j].pid == index) {
                            options.index = j;
                            break;
                        }
                    }
                } else {
                    // in URL indexes start from 1
                    options.index = parseInt(index, 10) - 1;
                }
            } else {
                options.index = parseInt(index, 10);
            }

            // exit if index not found
            if( isNaN(options.index) ) {
                return;
            }

            if(disableAnimation) {
                options.showAnimationDuration = 0;
            }

            // Pass data to PhotoSwipe and initialize it
            gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init();
        };

        // loop through all gallery elements and bind events
        var galleryElements = document.querySelectorAll( gallerySelector );

        for(var i = 0, l = galleryElements.length; i < l; i++) {
            galleryElements[i].setAttribute('data-pswp-uid', i+1);
            galleryElements[i].onclick = onThumbnailsClick;
        }

        // Parse URL and open gallery if it contains #&pid=3&gid=1
        var hashData = photoswipeParseHash();
        if(hashData.pid && hashData.gid) {
            openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
        }
    };

    $(document).ready(function(){
        // execute above function
        initPhotoSwipeFromDOM('.vehicle-gallery');
        var $vehicle_title = $('.main-vehicle-title').text();
        $('input#subject').val($vehicle_title);
        //alert($vehicle_title);
    });

      }
    }

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
